import DeterminationBadge from "../../components/DeterminationBadge";
import { statusTextColor } from "../../lib/constants";

function BulkRow({ r, index }) {
  return (
    <tr
      data-testid={`bulk-row-${index}`}
      className="border-t border-border/60 hover:bg-[#F9F9F8]"
    >
      <td className="px-4 py-3 font-mono text-xs">{r.normalized_parcel_id || r.parcel_id}</td>
      <td className="px-4 py-3">
        <span className={`text-xs font-medium ${statusTextColor(r.status)}`}>
          {r.status.replace("_", " ")}
        </span>
      </td>
      <td className="px-4 py-3">
        {r.determination_code ? (
          <DeterminationBadge code={r.determination_code} />
        ) : (
          <span className="text-[#5B695E]">—</span>
        )}
      </td>
      <td className="px-4 py-3 text-[#111812]">{r.address || "—"}</td>
      <td className="px-4 py-3 text-[#5B695E]">{r.date || "—"}</td>
      <td className="px-4 py-3 font-mono text-xs text-[#5B695E]">{r.range_slug || "—"}</td>
    </tr>
  );
}

export default function BulkResultsTable({ results }) {
  return (
    <div className="mt-6 bg-white border border-border/60 rounded-2xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="bulk-results-table">
          <thead className="bg-[#F4F5F4] text-[#5B695E]">
            <tr>
              <th className="text-left px-4 py-3 font-medium">Parcel</th>
              <th className="text-left px-4 py-3 font-medium">Status</th>
              <th className="text-left px-4 py-3 font-medium">Determination</th>
              <th className="text-left px-4 py-3 font-medium">Address</th>
              <th className="text-left px-4 py-3 font-medium">Date</th>
              <th className="text-left px-4 py-3 font-medium">Range</th>
            </tr>
          </thead>
          <tbody>
            {results.map((r, i) => (
              <BulkRow key={`${r.id}-${i}`} r={r} index={i} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
